function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { timeYear, timeMonth, timeHour, timeMinute, timeSecond } from "d3-time";
import { timeFormat } from "d3-time-format";
/**
    A default set of date formatters, which takes into account both the interval in between in each data point but also the start/end data points.
    @param d The date to format.
    @param dataArray The full array of ordered Date Objects.
    @param formatter Optional custom format string or function.
*/ export default function formatDate(d, dataArray) {
    var formatter = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : timeFormat;
    var formatHour = formatter("%I %p"), formatMillisecond = formatter(".%L"), formatMinute = formatter("%I:%M"), formatMonth = formatter("%b"), formatMonthDay = formatter("%b %-d"), formatMonthDayYear = formatter("%b %-d, %Y"), formatMonthYear = formatter("%b %Y"), formatQuarter = formatter("Q%q"), formatQuarterYear = formatter("Q%q %Y"), formatSecond = formatter(":%S"), formatYear = formatter("%Y");
    var labelIndex = dataArray.findIndex(function(a) {
        return +a === +d;
    });
    var firstOrLast = labelIndex === 0 || labelIndex === dataArray.length - 1;
    var smallArray = dataArray.length <= 5;
    var _dataArray_reduce = _sliced_to_array(dataArray.reduce(function(arr, d, i) {
        if (i) {
            arr[0].push(d.getFullYear() - dataArray[i - 1].getFullYear());
            arr[1].push(monthDiff(dataArray[i - 1], d));
            arr[2].push(Math.round((+d - +dataArray[i - 1]) / (1000 * 60 * 60 * 24)));
            arr[3].push(Math.round((+d - +dataArray[i - 1]) / (1000 * 60 * 60)));
        }
        return arr;
    }, [
        [],
        [],
        [],
        []
    ]), 4), yearlySteps = _dataArray_reduce[0], monthlySteps = _dataArray_reduce[1], dailySteps = _dataArray_reduce[2], hourlySteps = _dataArray_reduce[3];
    return (yearlySteps.every(function(s) {
        return s >= 1 && !(s % 1);
    }) // Yearly Data
     ? formatYear : monthlySteps.every(function(s) {
        return s >= 3 && !(s % 3);
    }) // Quarterly Data
     ? +timeYear(d) === +d || firstOrLast || smallArray ? formatQuarterYear : formatQuarter : monthlySteps.every(function(s) {
        return s >= 1 && !(s % 1);
    }) // Monthly Data
     ? +timeYear(d) === +d || firstOrLast || smallArray ? formatMonthYear : formatMonth : dailySteps.every(function(s) {
        return s >= 1 && !(s % 1);
    }) // Daily Data
     ? +timeYear(d) === +d || firstOrLast || smallArray ? formatMonthDayYear : formatMonthDay : hourlySteps.every(function(s) {
        return s >= 1 && !(s % 1);
    }) // Hourly Data
     ? firstOrLast || smallArray ? formatMonthDayYear : +timeMonth(d) === +d ? formatMonthDay : formatHour : timeSecond(d) < d ? formatMillisecond : timeMinute(d) < d ? formatSecond : timeHour(d) < d ? formatMinute : function(_d) {
        return _d.toString();
    })(d);
}
/**
    Returns the number of months between two Date objects

    @returns {Number} the number of months between the two Date objects
    @private
*/ function monthDiff(d1, d2) {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
}

//# sourceMappingURL=formatDate.js.map